module.exports = __webpack_public_path__ + "static/media/rajah.2da4e760.jpg";